import React from 'react'
import axios from 'axios'
import { Fragment, useState } from 'react'
import { useRef } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import "./index.css";
import { useNavigate } from 'react-router-dom'
import { USER_API, ClassOptions } from "../../functions"
import { useEffect } from 'react';
import { MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import 'react-phone-number-input/style.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';
import lottie from 'lottie-web';
import Swal from 'sweetalert2'

const Signup = () => {

    const navigate = useNavigate();
    const ref = useRef(null);
    const [done, setDone] = useState(false)
    const [loading, setLoading] = useState(false)

    const [selected, setSelected] = useState({ id: 0, name: "Choose a class" })

    const [studentDetails, setStudentDetails] = useState({
        StudentName: "",
        StudentFatherName: "",
        StudentEmail: "",
        StudentClass: "",
        StudentCity: "",
    });
    const checkuser = async () => {
        const user = Cookies.get("user")
        if (!user) {
            navigate("/login")
        }
    }

    useEffect(() => {
        checkuser()
    }, [])

    const Loader = () => {
        useEffect(() => {
            const Animator = lottie.loadAnimation({
                container: ref.current,
                animationData: require('../../Components/Animations/RegistrationSuccessful.json'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
            });
            Animator.setSpeed(0.75);
            Animator.addEventListener('complete', () => {
                if (done) {
                    navigate("/")
                }
                else {
                    Animator.loop = true;
                }
            })
            return () => Animator.destroy();
        }, [])

        return (
            <div className='flex justify-center items-center h-screen'>
                <div ref={ref} className='w-[min(100vw,50rem)]'></div>
            </div>
        );

    }


    const handleFormSubmit = async () => {

        let userID = localStorage.getItem("user")
        userID = JSON.parse(userID)


        const data = studentDetails;

        if (data.StudentName === "" || data.StudentFatherName === "" || data.StudentEmail === "" || data.StudentClass === "" || data.StudentCity === "") {
            toast.error("Please enter all the details")
            return
        }
        if (data.StudentEmail.indexOf("@") === -1 || data.StudentEmail.indexOf(".") === -1 || data.StudentEmail.indexOf("@") === 0 || data.StudentEmail.indexOf(".") === 0 || data.StudentEmail.indexOf("@") === data.StudentEmail.length - 1 || data.StudentEmail.indexOf(".") === data.StudentEmail.length - 1) {
            toast.error("Please enter a valid email address")
            return
        }

        try {
            const response = await axios.patch(`${USER_API}/setData/${userID}`, data)
            if (response.status === 201) {
                setLoading(true)
                setDone(true)
            }
            else {
                toast.error("Something went wrong")
            }
        }
        catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    }


    const ClassSelection = () => {

        const optionsClass = ClassOptions();
        function classNames(...classes) {
            return classes.filter(Boolean).join(' ')
        }

        return (

            <Listbox
                value={selected}
                onChange={(selectedOption) => {
                    setSelected(selectedOption);
                    setStudentDetails({ ...studentDetails, StudentClass: selectedOption.name })
                }}
            >
                {({ open }) => (
                    <div>
                        <Listbox.Label className="cursor-pointer block text-sm font-medium leading-6 text-gray-900">Class</Listbox.Label>
                        <div className="relative mt-2">
                            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:text-sm sm:leading-6">
                                <span className="flex items-center">
                                    <span className="ml-3 block truncate cursor-pointer">{selected.name}</span>
                                </span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                    <ChevronUpDownIcon className="h-5 w-5 text-gray-400 cursor-pointer" aria-hidden="true" />
                                </span>
                            </Listbox.Button>
                            <Transition
                                show={open}
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Listbox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                    {optionsClass.map((ClassOpt) => (
                                        <Listbox.Option
                                            key={ClassOpt.id}
                                            className={({ active }) =>
                                                classNames(
                                                    active ? 'bg-indigo-600 text-white' : 'text-gray-900',
                                                    'relative cursor-default select-none py-2 pl-3 pr-9'
                                                )
                                            }
                                            value={ClassOpt}
                                        >
                                            {({ selected, active }) => (
                                                <>
                                                    <div className="flex items-center">
                                                        <span
                                                            className={classNames(selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate')}
                                                        >
                                                            {ClassOpt.name}
                                                        </span>
                                                    </div>

                                                    {selected ? (
                                                        <span
                                                            className={classNames(
                                                                active ? 'text-white' : 'text-indigo-600',
                                                                'absolute inset-y-0 right-0 flex items-center pr-4'
                                                            )}
                                                        >
                                                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                        </span>
                                                    ) : null}
                                                </>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </Listbox.Options>
                            </Transition>
                        </div>
                    </div>
                )}
            </Listbox>
        );
    }

    return (
        <div>
            {loading ? (<Loader />) : (
                <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-6 lg:px-8">
                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                        <img
                            className="mx-auto w-40"
                            src={require(`../../assets/MainLogo.webp`)}
                        />
                        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                            Student Registration Form
                        </h2>
                    </div>

                    <MDBContainer className="p-1">

                        <MDBRow>

                            <MDBCol col='10' md='6'>
                                <img src={require(`../../assets/SignupPageImage.webp`)} className="img-fluid " alt="login" />
                            </MDBCol>

                            <MDBCol col='4' md='6' className='my-5 flex flex-col'>

                                <div className="space-y-6" >
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                                            Student Name
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="name"
                                                name="name"
                                                type="text"
                                                onChange={(e) => {
                                                    setStudentDetails({ ...studentDetails, StudentName: e.target.value })
                                                }}
                                                placeholder='Enter your name'
                                                // required
                                                className="block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                                            Student's Father Name
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="Fname"
                                                name="Fname"
                                                type="text"
                                                onChange={(e) => setStudentDetails({ ...studentDetails, StudentFatherName: e.target.value })}
                                                placeholder='Enter your father name'
                                                // required
                                                className="block w-full p-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                                            Email Address
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="email"
                                                name="email"
                                                type="email"
                                                onChange={(e) => setStudentDetails({ ...studentDetails, StudentEmail: e.target.value })}
                                                placeholder='Enter your email'
                                                // required
                                                className="block w-full p-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>

                                    <ClassSelection />

                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                                            City
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="city"
                                                name="city"
                                                type="text"
                                                onChange={(e) => setStudentDetails({ ...studentDetails, StudentCity: e.target.value })}
                                                placeholder='Enter your city'
                                                // required
                                                className="block w-full p-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <button
                                            onClick={() => {

                                                handleFormSubmit()
                                            }}
                                            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        >
                                            Submit details
                                        </button>
                                    </div>
                                </div>
                            </MDBCol>

                        </MDBRow>

                    </MDBContainer>
                </div>
            )}
        </div>
    )

}

export default Signup;